"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5160],{

/***/ 25242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q6": function() { return /* binding */ GoldCard; },
/* harmony export */   "SU": function() { return /* binding */ fmtChi; },
/* harmony export */   "iT": function() { return /* binding */ Delta; }
/* harmony export */ });
/* unused harmony export pickCardRows */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);



/** Định dạng nghìn đồng/chỉ: 14180 → "14,180" (như app) */ var fmtChi = function(n) {
    return n ? n.toLocaleString("en-US") : "—";
};
var Delta = function(param) {
    var value = param.value;
    return value ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        className: "tw-block tw-text-[11px] tw-leading-tight tw-mt-0.5 ".concat(value > 0 ? "tw-text-[#219B64]" : "tw-text-[#C0392B]"),
        children: [
            value > 0 ? "▲ +" : "▼ −",
            Math.abs(value).toLocaleString("en-US")
        ]
    }) : null;
};
var CARD_KEYS = [
    "BTMC VRTL",
    "PNJ TP.HCM",
    "SJC"
];
var pickCardRows = function(gold) {
    var rows = CARD_KEYS.map(function(k) {
        return gold.rows.find(function(r) {
            return r.name === k;
        });
    }).filter(Boolean);
    return rows.length ? rows : gold.rows.slice(0, 3);
};
/**
 * Thẻ giá vàng dùng chung (thiết kế an-thu-ui-update).
 * variant "card": trang chủ (có tiêu đề + nút xem đầy đủ). variant "band": khối trong /tin-tuc/ (chỉ bảng, cột căn giữa).
 */ var GoldCard = function(param) {
    var gold = param.gold, _className = param.className, className = _className === void 0 ? "" : _className, _variant = param.variant, variant = _variant === void 0 ? "card" : _variant;
    var band = variant === "band";
    var cols = band ? "tw-grid-cols-[1fr_84px_84px] sm:tw-grid-cols-[1fr_130px_130px] tw-text-center" : "tw-grid-cols-[1fr_64px_64px]";
    var num = band ? "tw-text-center" : "tw-text-right";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "tw-bg-white tw-border tw-border-solid tw-border-[#DECA95] tw-text-[#30220E] ".concat(className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "tw-p-4 tw-pb-3",
                children: [
                    !band && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "tw-m-0 tw-border-0 tw-border-l-[3px] tw-border-solid tw-border-[#AF9454] tw-pl-3 tw-text-[15px] tw-font-bold tw-uppercase tw-leading-tight",
                        children: "Gi\xe1 v\xe0ng h\xf4m nay"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "tw-m-0 ".concat(band ? "" : "tw-mt-2 tw-text-[#AF9454]", " tw-text-[13px]"),
                        children: "Ngh\xecn đồng/chỉ"
                    })
                ]
            }),
            gold ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "tw-grid ".concat(cols, " tw-gap-x-2 tw-bg-[#FEF8E0] tw-px-4 tw-py-3 tw-text-[13px] ").concat(band ? "tw-text-[#AF9454] tw-text-[14px]" : "tw-text-[#AF9454] tw-text-[11px]"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "tw-text-left",
                                children: "Sản phẩm"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: band ? "" : "tw-text-right",
                                children: "Mua v\xe0o"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: band ? "" : "tw-text-right",
                                children: "B\xe1n ra"
                            })
                        ]
                    }),
                    pickCardRows(gold).map(function(r) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "tw-grid ".concat(cols, " tw-gap-x-2 tw-items-start tw-px-4 tw-py-3 tw-text-[13px] ").concat(band ? "tw-border-0 tw-border-b tw-border-solid tw-border-[#DECA95]/40 tw-text-[15px]" : ""),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "tw-pt-0.5 tw-text-left",
                                    children: r.name
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "".concat(num, " ").concat(band ? "" : "tw-font-bold"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: band ? "tw-font-medium" : "",
                                            children: fmtChi(r.buy)
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Delta, {
                                            value: r.buyDelta
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "".concat(num, " ").concat(band ? "" : "tw-font-bold"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: band ? "tw-font-medium" : "",
                                            children: fmtChi(r.sell)
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Delta, {
                                            value: r.sellDelta
                                        })
                                    ]
                                })
                            ]
                        }, r.key);
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "tw-m-0 tw-bg-[#FEF8E0] tw-px-4 tw-py-3 tw-text-[12px] tw-text-[#AF9454]",
                        children: [
                            gold.source,
                            " \xb7 ",
                            gold.updatedAt
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "tw-m-0 tw-bg-[#FEF8E0] tw-px-4 tw-py-6 tw-text-[13px] tw-text-[#AF9454]",
                children: "Chưa c\xf3 dữ liệu gi\xe1 v\xe0ng. Vui l\xf2ng quay lại sau \xedt ph\xfat."
            }),
            !band && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "tw-p-4",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: "/bang-gia/gia-vang/",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        className: "tw-flex tw-min-h-[40px] tw-items-center tw-justify-center tw-bg-[#0F6656] tw-text-[13px] tw-font-medium !tw-text-white hover:!tw-text-white",
                        children: "Xem đầy đủ gi\xe1 v\xe0ng →"
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 35160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ JournalPriceLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/ui/MetaTag/index.tsx
var MetaTag = __webpack_require__(42031);
// EXTERNAL MODULE: ./components/ui/JsonLd/index.tsx
var JsonLd = __webpack_require__(59904);
// EXTERNAL MODULE: ./constants/business.ts
var business = __webpack_require__(56154);
// EXTERNAL MODULE: ./features/journal/components.tsx + 3 modules
var components = __webpack_require__(41046);
;// CONCATENATED MODULE: ./features/journal/forex-table.tsx




// Editorial priority for Vietnamese visitors; new source currencies follow by code.
var PRIORITY = [
    "USD",
    "EUR",
    "JPY",
    "CNY",
    "KRW",
    "GBP",
    "AUD",
    "CAD",
    "SGD",
    "CHF",
    "THB",
    "HKD",
    "MYR"
];
var CURRENCY_NAMES = {
    USD: "Đ\xf4 la Mỹ",
    EUR: "Euro",
    JPY: "Y\xean Nhật",
    CNY: "Nh\xe2n d\xe2n tệ",
    KRW: "Won H\xe0n Quốc",
    GBP: "Bảng Anh",
    AUD: "Đ\xf4 la \xdac",
    CAD: "Đ\xf4 la Canada",
    SGD: "Đ\xf4 la Singapore",
    CHF: "Franc Thụy Sĩ",
    THB: "Baht Th\xe1i Lan",
    HKD: "Đ\xf4 la Hồng K\xf4ng",
    MYR: "Ringgit Malaysia",
    DKK: "Krone Đan Mạch",
    INR: "Rupee Ấn Độ",
    KWD: "Dinar Kuwait",
    NOK: "Krone Na Uy",
    RUB: "R\xfap Nga",
    SAR: "Riyal Ả Rập X\xea \xdat",
    SEK: "Krona Thụy Điển",
    NZD: "Đ\xf4 la New Zealand",
    TWD: "Đ\xf4 la Đ\xe0i Loan"
};
var quote = function(value) {
    return value === null ? "—" : new Intl.NumberFormat("vi-VN", {
        maximumFractionDigits: 2
    }).format(value);
};
var fold = function(value) {
    return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/đ/g, "d").replace(/Đ/g, "D").toLowerCase();
};
var currencyName = function(rate) {
    return CURRENCY_NAMES[rate.code] || rate.name;
};
var ForexTable = function(param) {
    var data = param.data, _showHeading = param.showHeading, showHeading = _showHeading === void 0 ? true : _showHeading;
    var ref = (0,react.useState)(""), query = ref[0], setQuery = ref[1];
    var rates = (0,_to_consumable_array/* default */.Z)((data === null || data === void 0 ? void 0 : data.rates) || []).sort(function(a, b) {
        var aIndex = PRIORITY.indexOf(a.code);
        var bIndex = PRIORITY.indexOf(b.code);
        return (aIndex === -1 ? PRIORITY.length : aIndex) - (bIndex === -1 ? PRIORITY.length : bIndex) || a.code.localeCompare(b.code);
    });
    var search = fold(query.trim());
    var visible = rates.filter(function(rate) {
        return fold("".concat(rate.code, " ").concat(currencyName(rate), " ").concat(rate.name)).includes(search);
    });
    var sourceLink = /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        href: (data === null || data === void 0 ? void 0 : data.sourceUrl) || "https://www.vietcombank.com.vn/vi-VN/KHCN/Cong-cu-tien-ich/Ty-gia",
        target: "_blank",
        rel: "noopener noreferrer",
        className: "tw-font-medium tw-text-jr-green hover:tw-underline",
        children: [
            (data === null || data === void 0 ? void 0 : data.source) || "Vietcombank",
            " ↗"
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Section */.$0, {
        className: "!tw-pt-0 !tw-pb-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-mb-5 tw-flex tw-flex-col tw-gap-4 md:tw-flex-row md:tw-items-end md:tw-justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            showHeading && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "tw-font-jr tw-m-0 tw-text-[28px] md:tw-text-[36px] tw-font-normal",
                                children: "Tỷ gi\xe1 ngoại tệ."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "tw-mt-3 tw-mb-0 tw-text-[14px] md:tw-text-[15px] tw-text-jr-mute",
                                children: "Đơn vị: VND cho 1 đơn vị ngoại tệ."
                            })
                        ]
                    }),
                    data && /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        role: "search",
                        "aria-label": "Lọc ngoại tệ",
                        onSubmit: function(event) {
                            return event.preventDefault();
                        },
                        className: "tw-relative tw-w-full md:tw-w-[300px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "1.5",
                                className: "tw-pointer-events-none tw-absolute tw-left-3 tw-top-3 tw-h-5 tw-w-5 tw-text-jr-green",
                                "aria-hidden": "true",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                        cx: "10.5",
                                        cy: "10.5",
                                        r: "6.5"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "m16 16 5 5"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "search",
                                "aria-label": "T\xecm ngoại tệ",
                                placeholder: "T\xecm USD, Euro, Y\xean Nhật…",
                                value: query,
                                onChange: function(event) {
                                    return setQuery(event.target.value);
                                },
                                className: "tw-h-11 tw-w-full tw-rounded-md tw-border tw-border-jr-line tw-bg-white tw-pl-10 tw-pr-3 tw-text-[16px] md:tw-text-[14px] focus:tw-border-jr-green focus:tw-outline-none"
                            })
                        ]
                    })
                ]
            }),
            data ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-mb-4 tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-x-4 tw-gap-y-2 tw-text-[12px] tw-leading-relaxed tw-text-jr-mute",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "tw-m-0",
                                children: [
                                    "Nguồn: ",
                                    sourceLink,
                                    " \xb7 Cập nhật ",
                                    new Intl.DateTimeFormat("vi-VN", {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        hour12: false,
                                        timeZone: "Asia/Ho_Chi_Minh"
                                    }).format(new Date(data.updatedAt))
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "tw-m-0",
                                role: "status",
                                children: [
                                    search ? "".concat(visible.length, " / ").concat(rates.length) : rates.length,
                                    " ngoại tệ"
                                ]
                            })
                        ]
                    }),
                    visible.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-hidden md:tw-block tw-overflow-hidden tw-rounded-lg tw-border tw-border-jr-line tw-bg-white",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                    className: "tw-w-full tw-border-collapse tw-text-left",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("caption", {
                                            className: "tw-sr-only",
                                            children: "Tỷ gi\xe1 ngoại tệ Vietcombank theo đơn vị VND cho 1 đơn vị ngoại tệ"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                            className: "tw-bg-jr-green tw-text-white",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        scope: "col",
                                                        className: "tw-px-5 tw-py-4 tw-text-[13px] tw-font-medium",
                                                        children: "Ngoại tệ"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        scope: "col",
                                                        className: "tw-px-5 tw-py-4 tw-text-right tw-text-[13px] tw-font-medium",
                                                        children: "Mua tiền mặt"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        scope: "col",
                                                        className: "tw-px-5 tw-py-4 tw-text-right tw-text-[13px] tw-font-medium",
                                                        children: "Mua chuyển khoản"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        scope: "col",
                                                        className: "tw-px-5 tw-py-4 tw-text-right tw-text-[13px] tw-font-medium",
                                                        children: "B\xe1n ra"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                            children: visible.map(function(rate) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    className: "tw-border-0 tw-border-t tw-border-solid tw-border-jr-line ".concat(rate.code === "USD" ? "tw-bg-[#F0F5F0]" : "hover:tw-bg-[#FAFAF7]"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            scope: "row",
                                                            className: "tw-px-5 tw-py-4 tw-font-normal",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "tw-flex tw-items-center tw-gap-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "tw-inline-flex tw-h-10 tw-w-12 tw-shrink-0 tw-items-center tw-justify-center tw-rounded tw-text-[13px] tw-font-medium ".concat(rate.code === "USD" ? "tw-bg-jr-green tw-text-white" : "tw-bg-jr-band tw-text-jr-green"),
                                                                        children: rate.code
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "tw-text-[14px]",
                                                                        children: currencyName(rate)
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            className: "tw-px-5 tw-py-4 tw-text-right tw-tabular-nums tw-text-[16px]",
                                                            children: quote(rate.buyCash)
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            className: "tw-px-5 tw-py-4 tw-text-right tw-tabular-nums tw-text-[16px]",
                                                            children: quote(rate.buyTransfer)
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            className: "tw-px-5 tw-py-4 tw-text-right tw-tabular-nums tw-text-[16px] tw-font-medium tw-text-jr-green",
                                                            children: quote(rate.sell)
                                                        })
                                                    ]
                                                }, rate.code);
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-space-y-3 md:tw-hidden",
                                children: visible.map(function(rate) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                        "aria-label": rate.code,
                                        className: "tw-rounded-lg tw-border tw-border-jr-line tw-p-4 ".concat(rate.code === "USD" ? "tw-bg-[#F0F5F0]" : "tw-bg-white"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                className: "tw-m-0 tw-flex tw-items-center tw-gap-3 tw-text-[14px] tw-font-normal",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "tw-inline-flex tw-h-8 tw-min-w-[44px] tw-shrink-0 tw-items-center tw-justify-center tw-rounded tw-px-2 tw-text-[12px] tw-font-medium ".concat(rate.code === "USD" ? "tw-bg-jr-green tw-text-white" : "tw-bg-jr-band tw-text-jr-green"),
                                                        children: rate.code
                                                    }),
                                                    currencyName(rate)
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
                                                className: "tw-mt-4 tw-mb-0 tw-grid tw-grid-cols-3 tw-gap-2",
                                                children: [
                                                    {
                                                        label: "Mua tiền mặt",
                                                        value: rate.buyCash
                                                    },
                                                    {
                                                        label: "Chuyển khoản",
                                                        value: rate.buyTransfer
                                                    },
                                                    {
                                                        label: "B\xe1n ra",
                                                        value: rate.sell
                                                    }, 
                                                ].map(function(param, index) {
                                                    var label = param.label, value = param.value;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "tw-min-w-0",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                                className: "tw-text-[11px] tw-text-jr-mute",
                                                                children: label
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                                className: "tw-m-0 tw-mt-2 tw-tabular-nums tw-text-[14px] tw-font-medium ".concat(index === 2 ? "tw-text-jr-green" : "tw-text-jr-ink"),
                                                                children: quote(value)
                                                            })
                                                        ]
                                                    }, label);
                                                })
                                            })
                                        ]
                                    }, rate.code);
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tw-m-0 tw-rounded-lg tw-border tw-border-jr-line tw-bg-white tw-p-6 tw-text-[15px] tw-text-jr-mute",
                        role: "status",
                        children: "Kh\xf4ng t\xecm thấy ngoại tệ ph\xf9 hợp. H\xe3y thử m\xe3 tiền tệ hoặc t\xean kh\xe1c."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tw-mt-4 tw-mb-0 tw-text-[12px] tw-leading-relaxed tw-text-jr-mute",
                        children: "Dấu “—” l\xe0 mức gi\xe1 ng\xe2n h\xe0ng chưa c\xf4ng bố. Tỷ gi\xe1 mang t\xednh tham khảo; mức giao dịch được x\xe1c nhận tại thời điểm thực hiện."
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "tw-m-0 tw-rounded-lg tw-border tw-border-jr-line tw-bg-white tw-p-5 tw-text-[15px] tw-text-jr-mute",
                role: "status",
                children: [
                    "Chưa tải được tỷ gi\xe1 ngoại tệ. Xem trực tiếp tại ",
                    sourceLink,
                    "."
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./features/journal/gold-card.tsx
var gold_card = __webpack_require__(25242);
// EXTERNAL MODULE: ./features/journal/price-tabs.tsx
var price_tabs = __webpack_require__(16609);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./features/journal/diamond-config.ts
var diamond_config = __webpack_require__(55187);
;// CONCATENATED MODULE: ./features/journal/gia-report-lookup.tsx


var GiaReportLookup = function() {
    var ref = (0,react.useState)(""), value = ref[0], setValue = ref[1];
    var ref1 = (0,react.useState)(""), error = ref1[0], setError = ref1[1];
    var input = (0,react.useRef)(null);
    var reportNumber = value.trim().replace(/^GIA[\s:#-]*/i, "").replace(/[\s-]+/g, "");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: "tra-cuu-gia",
        "aria-labelledby": "gia-lookup-heading",
        className: "tw-scroll-mt-6 tw-rounded-lg tw-border tw-border-jr-line tw-bg-white tw-p-5 sm:tw-p-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                id: "gia-lookup-heading",
                className: "tw-m-0 tw-text-[16px] tw-font-medium",
                children: "Bạn đ\xe3 c\xf3 số b\xe1o c\xe1o GIA?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "tw-mt-2 tw-mb-4 tw-text-[13px] tw-leading-relaxed tw-text-jr-mute",
                children: "Nhập số b\xe1o c\xe1o để xem th\xf4ng số v\xe0 đối chiếu bản gốc tại GIA."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                "aria-label": "Tra cứu b\xe1o c\xe1o GIA",
                onSubmit: function(event) {
                    event.preventDefault();
                    if (!/^\d{1,20}$/.test(reportNumber)) {
                        var ref;
                        setError("Vui l\xf2ng nhập số b\xe1o c\xe1o GIA, chỉ gồm chữ số.");
                        (ref = input.current) === null || ref === void 0 ? void 0 : ref.focus();
                    } else {
                        setError("");
                        window.open("https://www.gia.edu/report-check?locale=en_US&reportno=".concat(encodeURIComponent(reportNumber)), "_blank", "noopener,noreferrer");
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: "gia-report-number",
                        className: "tw-mb-2 tw-block tw-text-[13px] tw-font-medium tw-text-jr-green",
                        children: "Số b\xe1o c\xe1o GIA"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-flex-col tw-gap-3 sm:tw-flex-row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                id: "gia-report-number",
                                ref: input,
                                type: "text",
                                inputMode: "numeric",
                                enterKeyHint: "go",
                                autoComplete: "off",
                                spellCheck: false,
                                required: true,
                                maxLength: 64,
                                value: value,
                                onChange: function(event) {
                                    setValue(event.target.value);
                                    setError("");
                                },
                                placeholder: "V\xed dụ: 2141438171",
                                "aria-invalid": !!error,
                                "aria-describedby": error ? "gia-report-error gia-report-hint" : "gia-report-hint",
                                className: "tw-h-11 tw-w-full tw-min-w-0 tw-flex-1 tw-rounded tw-border tw-border-jr-line tw-bg-white tw-px-3 tw-text-[16px] focus:tw-border-jr-green focus:tw-outline-none"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "submit",
                                className: "tw-flex tw-min-h-[44px] tw-shrink-0 tw-items-center tw-justify-center tw-gap-2 tw-rounded tw-border-0 tw-bg-jr-green tw-px-4 tw-text-[13px] tw-font-medium tw-text-white hover:tw-opacity-90 focus-visible:tw-outline-jr-gold",
                                children: [
                                    "Tra cứu tr\xean GIA ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        "aria-hidden": "true",
                                        children: "↗"
                                    })
                                ]
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        id: "gia-report-error",
                        role: "alert",
                        className: "tw-mt-2 tw-mb-0 tw-text-[13px] tw-text-[#AA3636]",
                        children: error
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        id: "gia-report-hint",
                        className: "tw-mt-3 tw-mb-0 tw-text-[12px] tw-text-jr-mute",
                        children: "Kết quả mở tr\xean gia.edu trong tab mới."
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./features/journal/diamond-calculator.tsx











var usdFormat = function(value) {
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0
    }).format(value);
};
var vndFormat = function(value) {
    return new Intl.NumberFormat("vi-VN", {
        maximumFractionDigits: 0
    }).format(value);
};
var selectedStyle = "tw-border-jr-green tw-bg-jr-green tw-text-white";
var idleStyle = "tw-border-jr-line tw-bg-white tw-text-jr-ink hover:tw-border-jr-green hover:tw-text-jr-green";
var ShapeIcon = function(param) {
    var shape = param.shape;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 40 40",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.2",
        className: "tw-h-7 tw-w-7",
        "aria-hidden": "true",
        children: shape === "round" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: "20",
                    cy: "20",
                    r: "15"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "m20 5 11 5 4 10-4 11-11 4-11-4-4-11 4-10 11-5Zm0 0L9 31m26-11H5m26-10L9 31M9 10l22 21M20 5v30"
                })
            ]
        }) : shape === "oval" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                    cx: "20",
                    cy: "20",
                    rx: "12",
                    ry: "17"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "m20 3 8 17-8 17-8-17L20 3Zm-12 17h24"
                })
            ]
        }) : shape === "pear" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M20 3C15 12 6 17 6 25a14 12 0 0 0 28 0c0-8-9-13-14-22Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "m20 3-7 23 7 11 7-11L20 3ZM6 25h28"
                })
            ]
        }) : shape === "heart" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M20 10C6-8-7 17 20 36 47 17 34-8 20 10Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "m20 10-8 11 8 15 8-15-8-11ZM4 18l8 3h16l8-3"
                })
            ]
        }) : shape === "marquise" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M20 2C3 15 3 25 20 38 37 25 37 15 20 2Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "m20 2-8 18 8 18 8-18-8-18ZM7 20h26"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: shape === "cushion" ? "M10 5Q5 5 5 11v18q0 6 6 6h18q6 0 6-6V11q0-6-6-6H10Z" : shape === "princess" ? "M5 5h30v30H5Z" : "m12 3-8 8v18l8 8h16l8-8V11l-8-8H12Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "m12 11-3 9 3 9h16l3-9-3-9H12Zm0 0L5 5m23 6 7-6M12 29l-7 6m23-6 7 6M9 20h22M20 11v18"
                })
            ]
        })
    });
};
var Choices = function(param) {
    var label = param.label, value = param.value, options = param.options, onChange = param.onChange;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
        className: "tw-m-0 tw-min-w-0 tw-border-0 tw-p-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                className: "tw-mb-3 tw-text-[13px] tw-font-medium tw-text-jr-mute",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-grid tw-gap-1.5 ".concat(options.length === 8 ? "tw-grid-cols-4 sm:tw-grid-cols-8" : "tw-grid-flow-col tw-auto-cols-fr"),
                children: options.map(function(option) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        "aria-pressed": value === option.value,
                        onClick: function() {
                            return onChange(option.value);
                        },
                        className: "tw-min-h-[42px] tw-min-w-0 tw-rounded tw-border tw-px-1 tw-py-2 tw-text-[12px] tw-font-medium focus-visible:tw-outline-jr-gold ".concat(value === option.value ? selectedStyle : idleStyle),
                        children: option.label
                    }, option.value);
                })
            })
        ]
    });
};
var DiamondCalculator = function(param) {
    var usd = param.usd, _initialEstimate = param.initialEstimate, initialEstimate = _initialEstimate === void 0 ? null : _initialEstimate, _showHeading = param.showHeading, showHeading = _showHeading === void 0 ? true : _showHeading;
    var ref = (0,react.useState)((0,_object_spread/* default */.Z)({}, diamond_config/* DEFAULT_DIAMOND_INPUT */.Vr)), input = ref[0], setInput = ref[1];
    var ref1 = (0,react.useState)("1.00"), caratText = ref1[0], setCaratText = ref1[1];
    var ref2 = (0,react.useState)(initialEstimate), result = ref2[0], setResult = ref2[1];
    var ref3 = (0,react.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,react.useState)(""), error = ref4[0], setError = ref4[1];
    var request = (0,react.useRef)(null);
    var update = function(key, value) {
        var ref;
        (ref = request.current) === null || ref === void 0 ? void 0 : ref.abort();
        setLoading(false);
        setInput(function(previous) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, previous), (0,_define_property/* default */.Z)({}, key, value));
        });
        setResult(null);
        setError("");
    };
    var calculate = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(snapshot) {
            var ref, controller, query, response, estimate, _error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (ref = request.current) === null || ref === void 0 ? void 0 : ref.abort();
                        controller = new AbortController();
                        request.current = controller;
                        setLoading(true);
                        setError("");
                        setResult(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        query = new URLSearchParams(Object.entries(snapshot).map(function(param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                            return [
                                key,
                                String(value)
                            ];
                        }));
                        return [
                            4,
                            fetch("/api/journal/diamond-price?".concat(query), {
                                signal: controller.signal
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        if (!response.ok) throw new Error("unavailable");
                        return [
                            4,
                            response.json()
                        ];
                    case 3:
                        estimate = _state.sent();
                        if (!controller.signal.aborted) setResult(estimate);
                        return [
                            3,
                            6
                        ];
                    case 4:
                        _error = _state.sent();
                        if (!controller.signal.aborted) setError("Chưa lấy được gi\xe1 từ StoneAlgo. Bạn c\xf3 thể thử lại hoặc xem trực tiếp tại nguồn.");
                        return [
                            3,
                            6
                        ];
                    case 5:
                        if (!controller.signal.aborted) setLoading(false);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function calculate(snapshot) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (!initialEstimate) calculate(diamond_config/* DEFAULT_DIAMOND_INPUT */.Vr);
        return function() {
            var ref;
            (ref = request.current) === null || ref === void 0 ? void 0 : ref.abort();
        };
    }, [
        initialEstimate
    ]);
    var sourceUrl = (result === null || result === void 0 ? void 0 : result.sourceUrl) || (input.carat >= 0.3 && input.carat <= 5 ? (0,diamond_config/* buildDiamondSourceUrl */.WB)(input) : "https://www.stonealgo.com/diamond-price-calculator/");
    var shape = diamond_config/* SHAPES.find */.HS.find(function(item) {
        return item.value === input.shape;
    });
    var displayDate = (result === null || result === void 0 ? void 0 : result.updatedAt) ? result.updatedAt.slice(0, 10).split("-").reverse().join("/") : "";
    var conversionRate = usd === null || usd === void 0 ? void 0 : usd.sell;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Section */.$0, {
        className: "!tw-pt-0 !tw-pb-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-mb-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GiaReportLookup, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-mb-6 tw-flex tw-flex-wrap tw-items-start tw-justify-between tw-gap-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            showHeading && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "tw-font-jr tw-m-0 tw-text-[26px] md:tw-text-[36px] tw-font-normal",
                                children: "Gi\xe1 kim cương."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "tw-mt-3 tw-mb-0 tw-text-[14px] md:tw-text-[15px] tw-text-jr-mute",
                                children: "Chọn th\xf4ng số để ước t\xednh gi\xe1 kim cương tự nhi\xean tr\xean thị trường quốc tế."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-border-jr-line tw-bg-white tw-px-3 tw-py-2 tw-text-[12px] tw-text-jr-green",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tw-h-1.5 tw-w-1.5 tw-rounded-full tw-bg-jr-green"
                            }),
                            "Tự nhi\xean \xb7 B\xe1o c\xe1o GIA"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-grid tw-items-start tw-gap-5 lg:tw-grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        onSubmit: function(event) {
                            event.preventDefault();
                            calculate(input);
                        },
                        className: "tw-min-w-0 tw-rounded-lg tw-border tw-border-jr-line tw-bg-white tw-p-4 sm:tw-p-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-flex tw-items-baseline tw-justify-between tw-gap-3 tw-border-0 tw-border-b tw-border-solid tw-border-jr-line tw-pb-5 tw-mb-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "tw-m-0 tw-text-[18px] tw-font-medium",
                                        children: "Th\xf4ng số vi\xean đ\xe1"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "tw-text-[11px] tw-tracking-widest tw-text-jr-gold",
                                        children: "01 — 4C"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
                                className: "tw-m-0 tw-min-w-0 tw-border-0 tw-p-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("legend", {
                                        className: "tw-mb-3 tw-text-[13px] tw-font-medium tw-text-jr-mute",
                                        children: [
                                            "H\xecnh dạng ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "tw-font-normal",
                                                children: [
                                                    "/ ",
                                                    shape.name
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tw-grid tw-grid-cols-5 tw-gap-1.5",
                                        children: diamond_config/* SHAPES.map */.HS.map(function(item) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                type: "button",
                                                title: item.name,
                                                "aria-label": "".concat(item.label, " (").concat(item.name, ")"),
                                                "aria-pressed": input.shape === item.value,
                                                onClick: function() {
                                                    return update("shape", item.value);
                                                },
                                                className: "tw-flex tw-min-w-0 tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-rounded tw-border tw-px-0.5 tw-py-3 focus-visible:tw-outline-jr-gold ".concat(input.shape === item.value ? selectedStyle : idleStyle),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShapeIcon, {
                                                        shape: item.value
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "tw-text-[10px] sm:tw-text-[11px]",
                                                        children: item.label
                                                    })
                                                ]
                                            }, item.value);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-my-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tw-flex tw-items-center tw-justify-between tw-gap-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                htmlFor: "diamond-carat",
                                                className: "tw-text-[13px] tw-font-medium tw-text-jr-mute",
                                                children: [
                                                    "Trọng lượng ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "tw-font-normal",
                                                        children: "/ Carat"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "tw-flex tw-items-center tw-gap-2 tw-rounded tw-border tw-border-jr-line tw-bg-[#F8FAF7] tw-px-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        id: "diamond-carat",
                                                        type: "number",
                                                        inputMode: "decimal",
                                                        min: "0.3",
                                                        max: "5",
                                                        step: "0.01",
                                                        required: true,
                                                        value: caratText,
                                                        onChange: function(event) {
                                                            setCaratText(event.target.value);
                                                            update("carat", Number(event.target.value));
                                                        },
                                                        className: "tw-h-10 tw-w-[64px] tw-border-0 tw-bg-transparent tw-text-right tw-text-[16px] tw-font-medium tw-text-jr-green focus:tw-outline-none"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "tw-text-[12px] tw-text-jr-mute",
                                                        children: "ct"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        "aria-label": "Điều chỉnh trọng lượng carat",
                                        type: "range",
                                        min: "0.3",
                                        max: "5",
                                        step: "0.01",
                                        value: input.carat || 0.3,
                                        onChange: function(event) {
                                            var value = Number(event.target.value);
                                            setCaratText(value.toFixed(2));
                                            update("carat", value);
                                        },
                                        className: "tw-mt-4 tw-w-full tw-accent-jr-green"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tw-mt-1 tw-flex tw-justify-between tw-text-[11px] tw-text-jr-mute",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "0.30 ct"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "5.00 ct"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-space-y-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Choices, {
                                        label: "M\xe0u sắc / Color",
                                        value: input.color,
                                        options: diamond_config/* COLORS.map */.DM.map(function(value) {
                                            return {
                                                value: value,
                                                label: value
                                            };
                                        }),
                                        onChange: function(value) {
                                            return update("color", value);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Choices, {
                                        label: "Độ tinh khiết / Clarity",
                                        value: input.clarity,
                                        options: diamond_config/* CLARITIES.map */.J6.map(function(value) {
                                            return {
                                                value: value,
                                                label: value
                                            };
                                        }),
                                        onChange: function(value) {
                                            return update("clarity", value);
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("details", {
                                className: "tw-mt-6 tw-border-0 tw-border-t tw-border-solid tw-border-jr-line tw-pt-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("summary", {
                                        className: "tw-cursor-pointer tw-text-[13px] tw-font-medium tw-text-jr-green",
                                        children: "Th\xf4ng số n\xe2ng cao"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tw-mt-5 tw-space-y-5",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Choices, {
                                                label: "Gi\xe1c cắt / Cut",
                                                value: input.cut,
                                                options: diamond_config/* GRADES */.Tw,
                                                onChange: function(value) {
                                                    return update("cut", value);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Choices, {
                                                label: "Đối xứng / Symmetry",
                                                value: input.symmetry,
                                                options: diamond_config/* GRADES */.Tw,
                                                onChange: function(value) {
                                                    return update("symmetry", value);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Choices, {
                                                label: "Đ\xe1nh b\xf3ng / Polish",
                                                value: input.polish,
                                                options: diamond_config/* GRADES */.Tw,
                                                onChange: function(value) {
                                                    return update("polish", value);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Choices, {
                                                label: "Huỳnh quang / Fluorescence",
                                                value: input.fluorescence,
                                                options: diamond_config/* FLUORESCENCE */.NY,
                                                onChange: function(value) {
                                                    return update("fluorescence", value);
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "submit",
                                disabled: loading,
                                className: "tw-mt-6 tw-flex tw-min-h-[48px] tw-w-full tw-items-center tw-justify-center tw-gap-3 tw-rounded tw-border-0 tw-bg-jr-green tw-px-4 tw-py-3 tw-text-[15px] tw-font-medium tw-text-white hover:tw-opacity-90 disabled:tw-opacity-60",
                                children: [
                                    loading ? "Đang tra cứu…" : "Xem gi\xe1 tham khảo",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        "aria-hidden": "true",
                                        children: "→"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-min-w-0 tw-space-y-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-overflow-hidden tw-rounded-lg tw-border tw-border-jr-line tw-bg-white",
                            "aria-live": "polite",
                            "aria-busy": loading,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-flex tw-items-center tw-justify-between tw-gap-2 tw-border-0 tw-border-b tw-border-solid tw-border-jr-line tw-px-5 sm:tw-px-7 tw-py-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "tw-m-0 tw-text-[16px] tw-font-medium",
                                            children: "Kết quả tham khảo"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "tw-text-[12px] tw-text-jr-mute",
                                            children: "Nguồn StoneAlgo ↗"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-bg-[#F0F5F0] tw-px-5 sm:tw-px-7 tw-py-8 sm:tw-py-10 tw-text-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Eyebrow */.j4, {
                                            children: "GI\xc1 ƯỚC T\xcdNH QUỐC TẾ"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "tw-mt-3 tw-mb-0 tw-text-[14px] tw-text-jr-green",
                                            children: [
                                                shape.name,
                                                " \xb7 ",
                                                Number.isFinite(input.carat) ? input.carat.toFixed(2) : "—",
                                                " ct \xb7 ",
                                                input.color,
                                                " \xb7 ",
                                                input.clarity
                                            ]
                                        }),
                                        result ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "tw-mt-4 tw-mb-0 tw-font-jr tw-text-[48px] sm:tw-text-[58px] tw-leading-tight tw-text-jr-green",
                                                    children: [
                                                        usdFormat(result.priceUsd),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "tw-ml-2 tw-font-sans tw-text-[13px] tw-text-jr-mute",
                                                            children: "USD"
                                                        })
                                                    ]
                                                }),
                                                conversionRate && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "tw-mt-3 tw-mb-0 tw-text-[16px] tw-text-jr-green",
                                                    children: [
                                                        "≈ ",
                                                        vndFormat(result.priceUsd * conversionRate),
                                                        " ₫"
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "tw-py-6",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "tw-m-0 tw-text-[22px] tw-font-medium tw-text-jr-green",
                                                    children: loading ? "Đang lấy gi\xe1 từ StoneAlgo…" : error ? "Chưa c\xf3 kết quả" : "Sẵn s\xe0ng tra cứu"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "tw-mt-3 tw-mb-0 tw-text-[14px] tw-leading-relaxed tw-text-jr-mute",
                                                    children: error || (loading ? "Vui l\xf2ng đợi trong gi\xe2y l\xe1t." : "Bấm “Xem gi\xe1 tham khảo” để cập nhật theo th\xf4ng số bạn chọn.")
                                                })
                                            ]
                                        }),
                                        result && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "tw-mt-4 tw-mb-0 tw-text-[12px] tw-text-jr-mute",
                                            children: [
                                                "Dữ liệu nguồn ng\xe0y ",
                                                displayDate
                                            ]
                                        }),
                                        (result === null || result === void 0 ? void 0 : result.stale) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "tw-mt-3 tw-mb-0 tw-text-[12px] tw-leading-relaxed tw-text-jr-mute",
                                            children: "Đang kiểm tra lại nguồn. Đ\xe2y l\xe0 gi\xe1 gần nhất theo ng\xe0y dữ liệu ở tr\xean."
                                        })
                                    ]
                                }),
                                result && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-grid tw-grid-cols-1 sm:tw-grid-cols-3 tw-divide-y sm:tw-divide-y-0 sm:tw-divide-x tw-divide-jr-line",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "tw-p-4 tw-text-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "tw-m-0 tw-text-[12px] tw-text-jr-mute",
                                                    children: "Khoảng gi\xe1 ước t\xednh"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "tw-mt-2 tw-mb-0 tw-text-[15px] tw-font-medium",
                                                    children: result.rangeMinUsd != null && result.rangeMaxUsd != null ? "".concat(usdFormat(result.rangeMinUsd), " – ").concat(usdFormat(result.rangeMaxUsd)) : "—"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "tw-p-4 tw-text-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "tw-m-0 tw-text-[12px] tw-text-jr-mute",
                                                    children: "Thay đổi 30 ng\xe0y"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "tw-mt-2 tw-mb-0 tw-text-[15px] tw-font-medium",
                                                    children: result.change30dPercent != null ? "".concat(result.change30dPercent > 0 ? "+" : "").concat(result.change30dPercent.toFixed(2), "%") : "—"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "tw-p-4 tw-text-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "tw-m-0 tw-text-[12px] tw-text-jr-mute",
                                                    children: "Gi\xe1 tr\xean mỗi carat"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "tw-mt-2 tw-mb-0 tw-text-[15px] tw-font-medium",
                                                    children: result.pricePerCaratUsd != null ? usdFormat(result.pricePerCaratUsd) : "—"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-p-5 sm:tw-p-7 tw-text-[13px] tw-leading-relaxed tw-text-jr-mute",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "tw-m-0",
                                            children: "Gi\xe1 b\xe1n lẻ ước t\xednh cho kim cương tự nhi\xean c\xf3 b\xe1o c\xe1o GIA. Gi\xe1 giao dịch tại An Thư được x\xe1c nhận theo từng vi\xean đ\xe1."
                                        }),
                                        result && conversionRate && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "tw-mt-3 tw-mb-0 tw-text-[12px]",
                                            children: [
                                                "Quy đổi theo tỷ gi\xe1 b\xe1n Vietcombank: ",
                                                vndFormat(conversionRate),
                                                " VND/USD \xb7 ",
                                                new Intl.DateTimeFormat("vi-VN", {
                                                    day: "2-digit",
                                                    month: "2-digit",
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                    hour12: false,
                                                    timeZone: "Asia/Ho_Chi_Minh"
                                                }).format(new Date(usd.updatedAt)),
                                                "."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            href: sourceUrl,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            className: "tw-mt-4 tw-inline-flex tw-items-center tw-gap-2 tw-font-medium tw-text-jr-green hover:tw-underline",
                                            children: [
                                                "Xem tại StoneAlgo ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    "aria-hidden": "true",
                                                    children: "↗"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./features/journal/diamond-catalogue-view.tsx
var diamond_catalogue_view = __webpack_require__(9354);
;// CONCATENATED MODULE: ./features/journal/price-guide.tsx



var GOLD_SOURCE = {
    label: "Gi\xe1 v\xe0ng tại 24h.com.vn",
    href: "https://www.24h.com.vn/gia-vang-hom-nay-c425.html"
};
var FOREX_SOURCE = {
    label: "Tỷ gi\xe1 tại Vietcombank",
    href: "https://www.vietcombank.com.vn/vi-VN/KHCN/Cong-cu-tien-ich/Ty-gia"
};
var DIAMOND_SOURCE = {
    label: "C\xf4ng cụ gi\xe1 StoneAlgo",
    href: "https://www.stonealgo.com/diamond-price-calculator/"
};
var GIA_SOURCE = {
    label: "T\xecm hiểu 4C tại GIA",
    href: "https://4cs.gia.edu/en-us/4cs-of-diamond-quality/"
};
var GUIDES = {
    overview: {
        title: "Chọn đ\xfang c\xf4ng cụ tham khảo",
        paragraphs: [
            "Bảng gi\xe1 tập hợp ba nguồn dữ liệu phục vụ những nhu cầu kh\xe1c nhau. Gi\xe1 v\xe0ng trong nước gi\xfap đối chiếu gi\xe1 mua v\xe0o, b\xe1n ra theo thương hiệu v\xe0 loại v\xe0ng. Bảng ngoại tệ hiển thị tỷ gi\xe1 Vietcombank theo VND cho một đơn vị tiền tệ. C\xf4ng cụ kim cương lấy ước t\xednh b\xe1n lẻ quốc tế từ StoneAlgo theo th\xf4ng số vi\xean đ\xe1.",
            "Mở từng bảng để xem đơn vị, nguồn v\xe0 thời điểm cập nhật. C\xe1c nguồn c\xf3 lịch c\xf4ng bố ri\xeang, n\xean số liệu giữa c\xe1c c\xf4ng cụ c\xf3 thể kh\xf4ng c\xf9ng thời điểm. Khi nguồn chưa trả dữ liệu, trang sẽ hiển thị th\xf4ng b\xe1o để bạn đối chiếu trực tiếp tại nguồn.",
            "Trước khi so s\xe1nh, h\xe3y chọn c\xf9ng loại v\xe0ng, h\xecnh thức đổi ngoại tệ hoặc th\xf4ng số kim cương. Gi\xe1 tham khảo hỗ trợ việc đọc th\xf4ng tin thị trường; gi\xe1 giao dịch cụ thể c\xf2n cần x\xe1c nhận với đơn vị b\xe1n tại thời điểm thực hiện.", 
        ],
        questions: [],
        sources: [
            GOLD_SOURCE,
            FOREX_SOURCE,
            DIAMOND_SOURCE
        ]
    },
    gold: {
        title: "C\xe1ch đọc bảng gi\xe1 v\xe0ng",
        paragraphs: [
            "Dữ liệu v\xe0ng được tổng hợp từ 24h.com.vn qua nguồn cấp gi\xe1 của An Thư. Mỗi nh\xf3m l\xe0 một thương hiệu; từng d\xf2ng thể hiện loại v\xe0ng được nguồn c\xf4ng bố. Đơn vị hiển thị l\xe0 ngh\xecn đồng/chỉ: chẳng hạn 15.000 tương ứng 15 triệu đồng cho một chỉ.",
            "“Mua v\xe0o” l\xe0 mức đơn vị kinh doanh mua v\xe0ng từ kh\xe1ch; “B\xe1n ra” l\xe0 mức b\xe1n cho kh\xe1ch. Số tăng, giảm b\xean dưới gi\xe1 phản \xe1nh ch\xeanh lệch với mức ghi nhận trước trong nguồn dữ liệu. H\xe3y xem thời điểm cập nhật v\xe0 đối chiếu c\xf9ng thương hiệu, loại v\xe0ng trước khi so s\xe1nh.", 
        ],
        questions: [
            {
                question: "C\xf3 thể d\xf9ng gi\xe1 v\xe0ng miếng để t\xednh gi\xe1 trang sức?",
                answer: "Cần đối chiếu h\xe0m lượng v\xe0ng, trọng lượng v\xe0 loại sản phẩm. Gi\xe1 trang sức c\xf2n phụ thuộc tiền c\xf4ng, đ\xe1 gắn k\xe8m v\xe0 ch\xednh s\xe1ch từng đơn vị."
            },
            {
                question: "V\xec sao gi\xe1 giao dịch c\xf3 thể kh\xe1c bảng?",
                answer: "Bảng phản \xe1nh thời điểm nguồn c\xf4ng bố. Gi\xe1 thực tế c\xf3 thể thay đổi khi giao dịch; h\xe3y x\xe1c nhận lại với đơn vị b\xe1n."
            }, 
        ],
        sources: [
            GOLD_SOURCE
        ]
    },
    forex: {
        title: "Đọc đ\xfang tỷ gi\xe1 ngoại tệ",
        paragraphs: [
            "Bảng sử dụng nguồn tỷ gi\xe1 c\xf4ng khai của Vietcombank, với đơn vị VND cho một đơn vị ngoại tệ. Bạn c\xf3 thể t\xecm bằng m\xe3 tiền tệ như USD, EUR, JPY hoặc t\xean tiếng Việt. Thời điểm cập nhật l\xe0 thời điểm ng\xe2n h\xe0ng c\xf4ng bố trong dữ liệu nguồn.",
            "C\xe1c cột được đọc từ ph\xeda ng\xe2n h\xe0ng: “Mua tiền mặt” khi ng\xe2n h\xe0ng mua ngoại tệ tiền mặt; “Mua chuyển khoản” khi mua ngoại tệ chuyển khoản; “B\xe1n ra” khi ng\xe2n h\xe0ng b\xe1n ngoại tệ. V\xed dụ, số VND tham khảo để mua 100 USD bằng 100 nh\xe2n với tỷ gi\xe1 b\xe1n USD.", 
        ],
        questions: [
            {
                question: "Dấu “—” c\xf3 nghĩa l\xe0 tỷ gi\xe1 bằng 0?",
                answer: "Dấu n\xe0y cho biết nguồn chưa c\xf4ng bố mức gi\xe1 tương ứng. Bạn c\xf3 thể mở trang Vietcombank để kiểm tra th\xeam."
            },
            {
                question: "Tỷ gi\xe1 n\xe0y \xe1p dụng cho mọi ng\xe2n h\xe0ng?",
                answer: "Đ\xe2y l\xe0 tỷ gi\xe1 tham khảo của Vietcombank. Ng\xe2n h\xe0ng kh\xe1c, phương thức giao dịch v\xe0 thời điểm thực hiện c\xf3 thể c\xf3 mức kh\xe1c."
            }, 
        ],
        sources: [
            FOREX_SOURCE
        ]
    },
    diamond: {
        title: "Hiểu gi\xe1 tham khảo kim cương",
        paragraphs: [
            "C\xf4ng cụ lấy ước t\xednh gi\xe1 b\xe1n lẻ kim cương tự nhi\xean từ StoneAlgo theo h\xecnh dạng, carat, m\xe0u sắc v\xe0 độ tinh khiết bạn chọn. Mở th\xf4ng số n\xe2ng cao để điều chỉnh gi\xe1c cắt, đối xứng, đ\xe1nh b\xf3ng v\xe0 huỳnh quang, rồi bấm xem gi\xe1 để cập nhật kết quả.",
            "GIA đ\xe1nh gi\xe1 đặc điểm v\xe0 chất lượng vi\xean đ\xe1 qua b\xe1o c\xe1o kiểm định; GIA kh\xf4ng c\xf4ng bố bảng gi\xe1 kim cương. Số tiền trong c\xf4ng cụ l\xe0 ước t\xednh của StoneAlgo, cần ph\xe2n biệt với th\xf4ng tin chất lượng tr\xean b\xe1o c\xe1o GIA. Ng\xe0y dữ liệu nguồn được ghi c\xf9ng kết quả.", 
        ],
        questions: [
            {
                question: "Số tiền VND được t\xednh thế n\xe0o?",
                answer: "Gi\xe1 USD được nh\xe2n với tỷ gi\xe1 b\xe1n USD của Vietcombank khi c\xf3 dữ liệu. Đ\xe2y l\xe0 quy đổi gi\xe1 vi\xean đ\xe1, chưa cộng vỏ trang sức hay tiền c\xf4ng."
            },
            {
                question: "Hai vi\xean c\xf9ng 4C c\xf3 lu\xf4n bằng gi\xe1?",
                answer: "Ước t\xednh kh\xf4ng thay thế việc xem từng vi\xean đ\xe1. Đặc điểm thực tế v\xe0 điều kiện b\xe1n c\xf3 thể tạo ch\xeanh lệch gi\xe1."
            }, 
        ],
        sources: [
            DIAMOND_SOURCE,
            GIA_SOURCE,
            {
                label: "GIA v\xe0 th\xf4ng tin gi\xe1",
                href: "https://www.gia.edu/FAQ/gia-faq-about-gia-trade-wholesale-price-list"
            }
        ]
    }
};
var PriceGuide = function(param) {
    var page = param.page;
    var guide = GUIDES[page];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Section */.$0, {
        className: "!tw-py-8",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-border-0 tw-border-t tw-border-solid tw-border-jr-line tw-pt-7",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "tw-font-jr tw-m-0 tw-text-[26px] md:tw-text-[34px] tw-font-normal",
                    children: guide.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-mt-5 tw-grid tw-gap-x-10 md:tw-grid-cols-2",
                    children: guide.paragraphs.map(function(paragraph) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "tw-mt-0 tw-mb-4 tw-text-[15px] tw-leading-relaxed tw-text-jr-mute",
                            children: paragraph
                        }, paragraph);
                    })
                }),
                guide.questions.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-mt-2 tw-grid tw-gap-3 md:tw-grid-cols-2",
                    children: guide.questions.map(function(param) {
                        var question = param.question, answer = param.answer;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("details", {
                            className: "tw-rounded-lg tw-border tw-border-solid tw-border-jr-line tw-bg-white tw-p-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("summary", {
                                    className: "tw-cursor-pointer tw-text-[15px] tw-font-medium tw-leading-relaxed tw-text-jr-green",
                                    children: question
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "tw-mt-3 tw-mb-0 tw-text-[14px] tw-leading-relaxed tw-text-jr-mute",
                                    children: answer
                                })
                            ]
                        }, question);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "tw-mt-5 tw-mb-0 tw-text-[13px] tw-leading-relaxed tw-text-jr-mute",
                    children: [
                        "Nguồn đối chiếu:",
                        " ",
                        guide.sources.map(function(source, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    index > 0 && " \xb7 ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: source.href,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: "tw-font-medium tw-text-jr-green tw-underline tw-underline-offset-4",
                                        children: source.label
                                    })
                                ]
                            }, source.href);
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./features/journal/market-pages.ts
var market_pages = __webpack_require__(71744);
;// CONCATENATED MODULE: ./features/journal/price.tsx

















var SITE = business/* BUSINESS.appUrl */.aL.appUrl;
var formatSourceTime = function(value) {
    return new Intl.DateTimeFormat("vi-VN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: "Asia/Ho_Chi_Minh"
    }).format(new Date(value));
};
var GoldTable = function(param) {
    var gold = param.gold;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-mx-auto tw-w-full tw-max-w-[1296px] tw-px-5 md:tw-px-8 tw-scroll-mt-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-2 tw-border tw-border-solid tw-border-[#DECA95] tw-bg-[#FEF8E0]/60 tw-px-5 tw-py-4 tw-text-[15px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "tw-m-0",
                            children: [
                                "Đơn vị: ",
                                (gold === null || gold === void 0 ? void 0 : gold.unit) || "Ngh\xecn đồng/chỉ"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "tw-m-0 tw-text-[#AF9454]",
                            children: gold ? "".concat(gold.source, " \xb7 Cập nhật ").concat(formatSourceTime(gold.updatedAtIso)) : "Chưa c\xf3 dữ liệu"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Section */.$0, {
                className: "!tw-pt-6 !tw-pb-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-overflow-hidden tw-border tw-border-solid tw-border-[#DECA95] tw-bg-white",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                className: "tw-w-full tw-table-fixed tw-border-collapse tw-text-left tw-text-[#30220E]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("caption", {
                                        className: "tw-sr-only",
                                        children: "Gi\xe1 v\xe0ng mua v\xe0o, b\xe1n ra theo thương hiệu, đơn vị ngh\xecn đồng/chỉ"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                                className: "tw-w-[88px] md:tw-w-[260px]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                                className: "tw-w-[88px] md:tw-w-[260px]"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                        className: "tw-bg-[#FEF8E0] tw-text-[14px] tw-text-[#AF9454]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    scope: "col",
                                                    className: "tw-px-3 md:tw-px-5 tw-py-4 tw-font-normal",
                                                    children: "Sản phẩm"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    scope: "col",
                                                    className: "tw-px-3 md:tw-px-5 tw-py-4 tw-text-right tw-font-normal",
                                                    children: "Mua v\xe0o"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    scope: "col",
                                                    className: "tw-px-3 md:tw-px-5 tw-py-4 tw-text-right tw-font-normal",
                                                    children: "B\xe1n ra"
                                                })
                                            ]
                                        })
                                    }),
                                    !gold && /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                colSpan: 3,
                                                className: "tw-px-5 tw-py-8 tw-text-jr-mute",
                                                children: "Chưa c\xf3 dữ liệu gi\xe1 v\xe0ng. Vui l\xf2ng quay lại sau \xedt ph\xfat."
                                            })
                                        })
                                    }),
                                    gold === null || gold === void 0 ? void 0 : gold.groups.map(function(group) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                                    className: "tw-bg-[#FEFCEF]",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        colSpan: 3,
                                                        scope: "rowgroup",
                                                        className: "tw-px-3 md:tw-px-5 tw-py-2 tw-text-[13px] tw-font-normal tw-text-[#AF9454]",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "tw-border-0 tw-border-l-2 tw-border-solid tw-border-[#AF9454] tw-pl-2",
                                                            children: group.brand
                                                        })
                                                    })
                                                }),
                                                group.rows.map(function(row) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                        className: "tw-border-0 tw-border-t tw-border-solid tw-border-[#DECA95]/50",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                scope: "row",
                                                                className: "tw-px-3 md:tw-px-5 tw-py-4 tw-align-top tw-text-[15px] md:tw-text-[17px] tw-font-normal",
                                                                children: row.name
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                                className: "tw-px-3 md:tw-px-5 tw-py-4 tw-align-top tw-text-right tw-tabular-nums tw-text-[18px] md:tw-text-[22px] tw-font-bold",
                                                                children: [
                                                                    (0,gold_card/* fmtChi */.SU)(row.buy),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gold_card/* Delta */.iT, {
                                                                        value: row.buyDelta
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                                className: "tw-px-3 md:tw-px-5 tw-py-4 tw-align-top tw-text-right tw-tabular-nums tw-text-[18px] md:tw-text-[22px] tw-font-bold",
                                                                children: [
                                                                    (0,gold_card/* fmtChi */.SU)(row.sell),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gold_card/* Delta */.iT, {
                                                                        value: row.sellDelta
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, row.key);
                                                })
                                            ]
                                        }, group.brand);
                                    })
                                ]
                            }),
                            gold && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "tw-m-0 tw-flex tw-flex-wrap tw-justify-between tw-gap-x-4 tw-bg-[#FEF8E0] tw-px-4 md:tw-px-5 tw-py-3 tw-text-[13px] tw-text-[#AF9454]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            "Nguồn ",
                                            gold.source,
                                            " \xb7 ",
                                            gold.unit
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            "Cập nhật ",
                                            formatSourceTime(gold.updatedAtIso)
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tw-mt-5 tw-mb-0 tw-text-[14px] tw-text-jr-mute",
                        children: "Gi\xe1 giao dịch tại An Thư được x\xe1c nhận theo sản phẩm v\xe0 thời điểm tư vấn."
                    })
                ]
            })
        ]
    });
};
var MarketOverview = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Section */.$0, {
        className: "!tw-pt-0 !tw-pb-6",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-grid tw-gap-4 md:tw-grid-cols-3",
            children: [
                [
                    "gold",
                    "Gi\xe1 v\xe0ng trong nước",
                    "So s\xe1nh gi\xe1 mua v\xe0o, b\xe1n ra theo thương hiệu, đọc mức ch\xeanh lệch v\xe0 biến động."
                ],
                [
                    "forex",
                    "Tỷ gi\xe1 ngoại tệ",
                    "Tra cứu USD, EUR, JPY v\xe0 c\xe1c ngoại tệ Vietcombank c\xf4ng bố. Lọc nhanh theo t\xean hoặc m\xe3."
                ],
                [
                    "diamond",
                    "Gi\xe1 kim cương tự nhi\xean",
                    "Chọn th\xf4ng số 4C để xem gi\xe1 tham khảo quốc tế; nhập số b\xe1o c\xe1o để đối chiếu tr\xean GIA."
                ], 
            ].map(function(param, index) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 3), key = _param[0], title = _param[1], description = _param[2];
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.A, {
                    href: market_pages/* MARKET_PAGES */.x_[key].path,
                    className: "tw-group tw-flex tw-flex-col tw-rounded-lg tw-border tw-border-jr-line tw-bg-white tw-p-6 hover:tw-border-jr-green",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "tw-text-[12px] tw-tracking-widest tw-text-jr-gold",
                            children: [
                                "0",
                                index + 1
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "tw-font-jr tw-mt-4 tw-mb-0 tw-text-[24px] tw-font-normal tw-text-jr-ink",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "tw-mt-4 tw-mb-5 tw-flex-1 tw-text-[14px] tw-leading-relaxed tw-text-jr-mute",
                            children: description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tw-text-[14px] tw-font-medium tw-text-jr-green group-hover:tw-underline",
                            children: "Mở bảng gi\xe1 →"
                        })
                    ]
                }, key);
            })
        })
    });
};
var JournalPriceLayout = function(param) {
    var _page = param.page, page = _page === void 0 ? "overview" : _page, gold = param.gold, _usd = param.usd, usd = _usd === void 0 ? null : _usd, _exchangeRates = param.exchangeRates, exchangeRates = _exchangeRates === void 0 ? null : _exchangeRates, _diamond = param.diamond, diamond = _diamond === void 0 ? null : _diamond, _catalogue = param.catalogue, catalogue = _catalogue === void 0 ? null : _catalogue;
    var router = (0,next_router.useRouter)();
    var info = market_pages/* MARKET_PAGES */.x_[page];
    var url = "".concat(SITE).concat(info.path);
    var modified = page === "gold" ? gold === null || gold === void 0 ? void 0 : gold.updatedAtIso : page === "forex" ? exchangeRates === null || exchangeRates === void 0 ? void 0 : exchangeRates.updatedAt : page === "diamond" ? diamond === null || diamond === void 0 ? void 0 : diamond.updatedAt : undefined;
    // Old entry-point fragments survive the redirect to the default diamond tool.
    (0,react.useEffect)(function() {
        var openLegacyTool = function() {
            var destination = (0,market_pages/* marketFragmentPath */.qb)(window.location.hash.slice(1));
            if (destination && destination !== info.path) router.replace(destination, undefined, {
                scroll: false
            });
        };
        openLegacyTool();
        window.addEventListener("hashchange", openLegacyTool);
        return function() {
            return window.removeEventListener("hashchange", openLegacyTool);
        };
    }, [
        info.path,
        router
    ]);
    var crumbs = [
        {
            label: "Trang chủ",
            href: "/"
        },
        (0,_object_spread/* default */.Z)({
            label: "Bảng gi\xe1"
        }, page === "overview" ? {} : {
            href: market_pages/* MARKET_PAGES.overview.path */.x_.overview.path
        }), 
    ].concat((0,_to_consumable_array/* default */.Z)(page === "overview" ? [] : [
        {
            label: info.label
        }
    ]));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* JournalShell */.C2, {
        activeKey: "bang-gia",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTag/* default */.Z, {
                title: info.title,
                description: info.description,
                handle: info.path,
                image: "".concat(SITE, "/logo-bg.png")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JsonLd/* default */.Z, {
                schema: [
                    {
                        "@context": "https://schema.org",
                        "@type": "BreadcrumbList",
                        itemListElement: crumbs.map(function(crumb, index) {
                            return {
                                "@type": "ListItem",
                                position: index + 1,
                                name: crumb.label,
                                item: "".concat(SITE).concat("href" in crumb && crumb.href ? crumb.href : info.path)
                            };
                        })
                    },
                    (0,_object_spread/* default */.Z)({
                        "@context": "https://schema.org",
                        "@type": page === "overview" ? "CollectionPage" : "WebPage",
                        "@id": "".concat(url, "#page"),
                        url: url,
                        name: info.title,
                        description: info.description,
                        inLanguage: "vi",
                        publisher: {
                            "@id": business/* BUSINESS.id */.aL.id
                        }
                    }, modified ? {
                        dateModified: modified
                    } : {}), 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Breadcrumb */.aG, {
                items: crumbs
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-mx-auto tw-w-full tw-max-w-[1296px] tw-px-5 md:tw-px-8 tw-pt-6 md:tw-pt-8 tw-pb-6 md:tw-pb-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Eyebrow */.j4, {
                            children: "AN THƯ \xb7 BẢNG GI\xc1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "tw-font-jr tw-mt-3 tw-mb-0 tw-text-[28px] md:tw-text-[44px] lg:tw-text-[48px] tw-font-normal tw-leading-[1.15]",
                            children: info.heading
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "tw-mt-3 tw-mb-0 tw-text-[14px] md:tw-text-[17px] tw-text-jr-mute",
                            children: info.intro
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(price_tabs/* PriceTabs */.A, {
                active: page
            }),
            page === "overview" && /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketOverview, {}),
            page === "gold" && /*#__PURE__*/ (0,jsx_runtime.jsx)(GoldTable, {
                gold: gold
            }),
            page === "forex" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ForexTable, {
                data: exchangeRates,
                showHeading: false
            }),
            page === "diamond" && /*#__PURE__*/ (0,jsx_runtime.jsx)(DiamondCalculator, {
                usd: usd,
                initialEstimate: diamond,
                showHeading: false
            }),
            page === "diamond" && catalogue && /*#__PURE__*/ (0,jsx_runtime.jsx)(diamond_catalogue_view/* DiamondCatalogue */.ZS, {
                data: catalogue,
                usd: usd
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceGuide, {
                page: page
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Section */.$0, {
                className: "!tw-py-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-grid tw-gap-6 md:tw-grid-cols-[1fr_auto] md:tw-items-center tw-bg-jr-band tw-p-6 md:tw-p-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Eyebrow */.j4, {
                                    children: "C\xd9NG AN THƯ LỰA CHỌN"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "tw-font-jr tw-mt-3 tw-mb-0 tw-text-[26px] md:tw-text-[34px] tw-font-normal tw-leading-[1.25]",
                                    children: "Hiểu gi\xe1 trị. Chọn điều ph\xf9 hợp."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "tw-mt-3 tw-mb-0 tw-text-[15px] tw-text-jr-mute",
                                    children: "Trang sức kim cương tự nhi\xean, chế t\xe1c từ v\xe0ng 14K v\xe0 18K."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-flex tw-flex-col tw-gap-3 md:tw-min-w-[280px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                                    href: "/danh-muc/trang-suc-kim-cuong-tu-nhien/",
                                    children: "Kh\xe1m ph\xe1 trang sức"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                                    href: "/accounts/appointment/new/",
                                    tone: "light",
                                    children: "Tư vấn gi\xe1 kim cương"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Section */.$0, {
                className: "!tw-pt-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "tw-font-jr tw-m-0 tw-mb-8 tw-text-[28px] md:tw-text-[40px] tw-font-normal",
                        children: "Kiến thức về v\xe0ng & bảo quản"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CardGrid */.gy, {
                        cols: 3,
                        items: [
                            {
                                title: "14K, 18K v\xe0 24K",
                                desc: "T\xecm hiểu h\xe0m lượng v\xe0ng.",
                                href: "/tin-tuc/?q=".concat(encodeURIComponent("v\xe0ng")),
                                label: "T\xecm hiểu"
                            },
                            {
                                title: "V\xe0ng trắng & bạch kim",
                                desc: "Hiểu kh\xe1c biệt về chất liệu.",
                                href: "/tin-tuc/?q=".concat(encodeURIComponent("v\xe0ng trắng")),
                                label: "T\xecm hiểu"
                            },
                            {
                                title: "Chăm s\xf3c trang sức",
                                desc: "Giữ vẻ đẹp qua từng lần đeo.",
                                href: "/tin-tuc/vang-bao-quan/",
                                label: "T\xecm hiểu"
                            }, 
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ExploreMore */.hf, {
                exclude: "bang-gia"
            })
        ]
    });
};


/***/ })

}]);